module.exports = __webpack_public_path__ + "static/img/009 1.b8a4d72f.jpg";